import { filter, map, orderBy, partition } from 'lodash'

export const getAvailablePositionTransfersForMultiselect = (
  punchCard: Partial<MData.PunchCard> | undefined,
  selectedShift: Partial<MData.Event> | undefined,
  userInfo: Partial<MData.CurrentUser['userInfo']>,
  t: (key: string) => string,
  getAssignablePositions: ({ forMultiSelect }: { forMultiSelect: boolean }) => Partial<MData.Position>[]
) => {
  const userAttributes = userInfo?.attributes || []
  const assignablePositions = getAssignablePositions({ forMultiSelect: false })
  const currentPositionId = getCurrentPositionId(punchCard, selectedShift)
  const assignablePositionsWithoutCurrentPosition = filter(assignablePositions, position => position._id !== currentPositionId)
  const filteredPositionOptions = partition(assignablePositionsWithoutCurrentPosition, position => filterUserPositionsFunction(position, userAttributes))

  return parsePositionOptions(filteredPositionOptions, t)
}

const getCurrentPositionId = (punchCard: Partial<MData.PunchCard> | undefined, selectedShift: Partial<MData.Event> | undefined) => {
  if (!punchCard || !selectedShift) return null
  const positionTransfers = filter(punchCard.transfers, transfer => transfer.toPosition) as MData.Transfer[]
  const lastPositionTransfer = positionTransfers.pop()
  const punchCardPosition = punchCard.positionId

  return lastPositionTransfer ? lastPositionTransfer.toPosition : punchCardPosition ? punchCardPosition : selectedShift.positionId
}

const filterUserPositionsFunction = (position: Partial<MData.Position>, userAttributes: MData.User['attributes']) => {
  const userAttributesIds = map(userAttributes, 'attributeId')
  const userHasAllAttributes = position.attributes?.every(({ attributeId }) => userAttributesIds.includes(attributeId))
  return userHasAllAttributes
}

const parsePositionOptions = (positionOptions: [Partial<MData.Position>[], Partial<MData.Position>[]], t: (key: string) => string) => {
  const [positionsSkilledOptions, positionsNotSkilledOptions] = positionOptions

  return [
    {
      label: t(`employee.punch.TRANSFER_MODAL.TRAINED`),
      options: orderBy(positionsSkilledOptions, ['name']).map(({ _id, name }) => ({ value: _id, label: name }))
    },
    {
      label: t(`employee.punch.TRANSFER_MODAL.NOT_TRAINED`),
      options: orderBy(positionsNotSkilledOptions, ['name']).map(({ _id, name }) => ({ value: _id, label: name }))
    }
  ]
}
